<template>
  <BaseDataIterator :service="fetchAudiences">
    <template #custom-actions="dataIteratorProps">
      <BaseButton primary outline @click="gridView = !gridView">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            v-if="gridView"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 10h16M4 14h16M4 18h16"
          />
          <path
            v-else
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
      </BaseButton>
      <AudienceCreateAction
        :account-id="accountId"
        :on-created="dataIteratorProps.queryContext.actions.execute"
      />
    </template>
    <template #default="dataIteratorProps">
      <div v-if="gridView" key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="3" class="gap-6">
          <AudienceCard
            v-for="item in dataIteratorProps.data"
            :audience="item"
            :key="item.id"
            @audience-updated="dataIteratorProps.fetchList"
            @audience-synced="dataIteratorProps.fetchList"
            @audience-deleted="dataIteratorProps.fetchList"
          />
        </BaseGrid>
      </div>
      <BaseDataTable v-else key="table_view" :data="audiences">
        <template #header>
          <AudienceTableListHeader />
        </template>
        <template #default="tableProps">
          <AudienceTableListItem
            :key="tableProps.item.id"
            :audience="tableProps.item"
            @audience-updated="dataIteratorProps.fetchList"
            @audience-synced="dataIteratorProps.fetchList"
            @audience-deleted="dataIteratorProps.fetchList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountAudiencesClient } from '@/api/clients';
// import { merge } from 'lodash-es';
import AudienceCard from './AudienceCard.vue';
import AudienceTableListHeader from './AudienceTableListHeader.vue';
import AudienceTableListItem from './AudienceTableListItem.vue';
import AudienceCreateAction from './AudienceCreateAction.vue';

export default {
  components: {
    AudienceTableListHeader,
    AudienceTableListItem,
    AudienceCreateAction,
    AudienceCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      audiences: [],
      gridView: true,
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.accountId];
    },
  },
  methods: {
    // resetList() {
    //   this.$refs.dataList.resetList();
    // },
    // refreshList() {
    //   this.$refs.dataList.fetchList();
    // },
    async fetchAudiences(params = {}) {
      try {
        const response = await accountAudiencesClient.list(this.accountId, {
          ...params,
          include: 'model.account,cover',
        });

        this.audiences = response.data;

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // updateAudience(newAudience) {
    //   this.audiences = this.audiences.map((audience) => {
    //     if (audience.id !== newAudience.id) {
    //       return audience;
    //     }

    //     return merge(audience, newAudience);
    //   });
    // },
  },
};
</script>
